import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { LinkList } from '../../components/Footer/LinkList.js';
import { useLink } from '../../hooks/useLink.js';
import { getAspectsAttributes } from '../../utils/dataAttributes.js';
import { style } from '../../utils/style.js';
import { isVisibleItem } from './isVisibleItem.js';
const FOOTER_AREA_KEYS = ['all', 'footer'];
export const Sitemap = JSX(({ className, navigationItems }) => {
    const link = useLink();
    return (_jsx("div", { role: "menu", className: style('w-full flex items-start justify-between flex-col md:flex-row gap-y-m lg:order-2', className), children: navigationItems?.filter(isVisibleItem(FOOTER_AREA_KEYS)).map(link).map(renderColumn) }));
});
const renderColumn = (menuItem, index) => {
    const { text, items = [], href, target = '_self', onClick, dataFooter } = menuItem;
    const visibleSubItems = items.filter(isVisibleItem(FOOTER_AREA_KEYS));
    return (_jsxs("div", { role: "menuitem", className: "flex flex-col gap-s w-full @md:w-1/4", children: [_jsx("a", { className: "leading-5 text-l text-primary-text hover:text-primary-main no-underline", href: href, target: target, onClick: onClick, ...getAspectsAttributes(dataFooter), children: text }), visibleSubItems ? _jsx(LinkList, { items: visibleSubItems }) : null] }, String(index)));
};
//# sourceMappingURL=Sitemap.js.map